var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowUpCircle = function SvgArrowUpCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 10a8 8 0 1 1 16 0 8 8 0 0 1-16 0Zm4.375-.624-.058.067a.6.6 0 0 0-.006.706l.064.075.067.058a.6.6 0 0 0 .707.006l.075-.064L9.399 8.05V13.4l.006.081a.6.6 0 0 0 .513.513l.081.006.082-.006a.6.6 0 0 0 .513-.513l.005-.081V8.049l2.177 2.176.067.058a.6.6 0 0 0 .84-.84l-.059-.067-3.2-3.2-.067-.059a.6.6 0 0 0-.706-.006l-.075.064-3.2 3.2-.059.068.058-.067Z",
    fill: "#666"
  })));
};
export default SvgArrowUpCircle;